import request from '@/utilsCloud/request'
import port from './port'

// 获取公共课程库列表菜单
export function getUnderlineCourseDetail(query) {
  return request({
    url: port.course + '/enterprise/underline/getUnderlineCourseDetail',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 保存报名
export function saveUnderlineRegisterCourse(query) {
  return request({
    url: port.course + '/enterprise/underline/saveUnderlineRegisterCourse',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: query
  })
}




// WEBPACK FOOTER //
// ./src/apiCloud/offlineApply.js